import DeliveryAddressSearch from 'app/components/Core/DeliveryAddress/Search'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'

type DeliveryAddressSearchProps = React.ComponentProps<typeof DeliveryAddressSearch>

export default function useAddressSearch() {
  const { tCore } = useTranslation({
    scope: 'drawer',
    recordType: RecordType.checkout
  })

  const { drawerfy } = useFeedbacker()

  const open = (props: DeliveryAddressSearchProps) => {
    drawerfy.open({
      content: <DeliveryAddressSearch {...props} />,
      title: tCore({
        id: 'delivery_address'
      }),
      width: 600,
      drawerType: 'page',
      push: false
    })
  }

  return { open, close: drawerfy.close }
}
